import { TypeEnum } from "@/types/types";
import { useEffect, useRef, useState } from "react";
import styles from "../page-searchbar.module.css";
import { MdApartment, MdBusiness, MdHouse, MdLandscape } from "react-icons/md";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { BsHousesFill } from "react-icons/bs";
import { usePageStore } from "../../../usePageStore";
import { IoIosArrowDown } from "react-icons/io";

export default function TypeSelectorClient({
  t,
  type,
  refetchState,
  fullWidth,
}: {
  t: any;
  type: TypeEnum;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
}) {
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const typeListRef = useRef<HTMLDivElement>(null);
  const setType = usePageStore((state) => state.setType);
  const typeListStyles = useDropdownPosition(typeListRef, isTypeOpen, {
    customWidth: 240, // px
    fullWidth: fullWidth,
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        typeListRef.current &&
        !typeListRef.current.contains(event.target as Node)
      ) {
        setIsTypeOpen(false); //this will close it
      }
    };
    if (isTypeOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTypeOpen]);

  return (
    <div
      className={`${styles.selectWrapper} ${styles.typeItemWrapper} ${
        fullWidth && styles.fullWidth
      }`}
      ref={typeListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsTypeOpen(!isTypeOpen);
        }}
        className={`${styles.pill} ${isTypeOpen && styles.pillOpen}`}
      >
        <div className={styles.textWrapper}>
          <span>{t(type)}</span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
      {isTypeOpen && typeListStyles.top && (
        <ul className={`${styles.selectionList}`} style={typeListStyles}>
          <SelectorComponentListItem
            text={t("apartment-house")}
            icon={<BsHousesFill />}
            isActive={type === TypeEnum.APARTMENT_HOUSE}
            onClick={async () => {
              setType(TypeEnum.APARTMENT_HOUSE);
              setIsTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t("apartment")}
            icon={<MdApartment />}
            isActive={type === TypeEnum.APARTMENT}
            onClick={async () => {
              setType(TypeEnum.APARTMENT);
              setIsTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t("house")}
            icon={<MdHouse />}
            isActive={type === TypeEnum.HOUSE}
            onClick={async () => {
              setType(TypeEnum.HOUSE);
              setIsTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t("land")}
            icon={<MdLandscape />}
            isActive={type === TypeEnum.LAND}
            onClick={async () => {
              setType(TypeEnum.LAND);
              setIsTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t("office")}
            icon={<MdBusiness />}
            isActive={type === TypeEnum.OFFICE}
            onClick={async () => {
              setType(TypeEnum.OFFICE);
              setIsTypeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
        </ul>
      )}
    </div>
  );
}
